import PropTypes from "prop-types";

import { STEP_STORAGE_KEYS } from "../constants/storageConstants";
import UploadButton from "./UploadButton";

const isValidProjectJson = (projectData) => {
  const storageKeys = Object.values(STEP_STORAGE_KEYS);
  return Object.keys(projectData).every((key) =>
    storageKeys.find((storageKey) => key === storageKey)
  );
};

export default function UploadProjectButton({
  children,
  color = "secondary",
  name,
  onUpload,
  register,
  sx,
  value,
  variant = "contained",
}) {
  return (
    <UploadButton
      accept=".json"
      color={color}
      name={name}
      onUpload={() => {
        const file = value[0];
        if (file) {
          const fileReader = new FileReader();
          fileReader.readAsText(file, "UTF-8");
          fileReader.onload = (event) => {
            const uploadedProjectData = JSON.parse(event.target.result);
            if (isValidProjectJson(uploadedProjectData)) {
              return onUpload(uploadedProjectData);
            }
            alert("File is not a valid PennDOT Web ICE project");
          };
        }
      }}
      register={register}
      sx={sx}
      value={value}
      variant={variant}
    >
      {children}
    </UploadButton>
  );
}

UploadProjectButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  name: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  sx: PropTypes.object,
  value: PropTypes.object,
  variant: PropTypes.string,
};
